import { render } from "./Access.vue?vue&type=template&id=52448eb4&scoped=true"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-52448eb4"

export default script